import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

import { LoomPageHeaderPlaceholder } from './LoomPageHeaderPlaceholder';

export const PageHeaderLoomEntryPoint = LoadableAfterPaint({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-PageHeaderLoomEntryPoint" */ './PageHeaderLoomEntryPoint'
			)
		).PageHeaderLoomEntryPoint;
	},
	loading: ({ isCircle }) => <LoomPageHeaderPlaceholder isCircle={isCircle} isEnabled />,
});
